(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class DeliveryCountdown extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('.delivery-countdown__text');
      this.cutoffHour = parseInt(this.dataset.cutoffHour, 10) || 15;
      this.cutoffMinute = parseInt(this.dataset.cutoffMinute, 10) || 0;
      this.timezone = this.dataset.timezone || 'Europe/London';
      this.holidayMode = this.dataset.holidayMode === 'true';
      this.holidayMessage = this.dataset.holidayMessage || '';
      this.headingText = this.dataset.headingText || '';
      this.subText = this.dataset.subText || '';

      if (this.holidayMode) {
        this.renderHolidayMessage();
        return;
      }

      this.update();
      this.interval = setInterval(this.update.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    getZonedParts() {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: this.timezone,
        hour12: false,
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
      const parts = formatter.formatToParts(new Date());
      const map = {};
      parts.forEach((p) => { map[p.type] = p.value; });
      return map;
    }

    update() {
      const parts = this.getZonedParts();
      const weekday = parts.weekday;
      const year = parseInt(parts.year, 10);
      const month = parseInt(parts.month, 10);
      const day = parseInt(parts.day, 10);
      let hour = parseInt(parts.hour, 10);
      if (hour === 24) hour = 0;
      const minute = parseInt(parts.minute, 10);
      const second = parseInt(parts.second, 10);

      const nowRef = Date.UTC(year, month - 1, day, hour, minute, second);
      const cutoffRef = Date.UTC(year, month - 1, day, this.cutoffHour, this.cutoffMinute, 0);

      const isWeekend = weekday === 'Sat' || weekday === 'Sun';
      const isFriday = weekday === 'Fri';
      const pastCutoff = nowRef >= cutoffRef;

      if (isWeekend) {
        this.renderDispatchDay('Monday');
        return;
      }
      if (isFriday && pastCutoff) {
        this.renderDispatchDay('Monday');
        return;
      }
      if (pastCutoff) {
        this.renderDispatchDay('Tomorrow');
        return;
      }

      const remaining = cutoffRef - nowRef;
      this.renderCountdown(remaining);
    }

    renderCountdown(remainingMs) {
      const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      const seconds = String(totalSeconds % 60).padStart(2, '0');

      this.textEl.innerHTML =
        '<span class="delivery-countdown__heading">' + this.headingText + '</span>' +
        '<span class="delivery-countdown__timer">' + hours + ':' + minutes + ':' + seconds + '</span>' +
        '<span class="delivery-countdown__sub">' + this.subText + '</span>';
    }

    renderDispatchDay(day) {
      this.textEl.innerHTML =
        '<span class="delivery-countdown__dispatch">Dispatch ' + day + '</span>';
    }

    renderHolidayMessage() {
      this.textEl.innerHTML =
        '<span class="delivery-countdown__holiday">' + this.holidayMessage + '</span>';
    }
  }

  if (!customElements.get('delivery-countdown')) {
    customElements.define('delivery-countdown', DeliveryCountdown);
  }




  } catch(e) { console.error(e); }
})();
})();
